import { queryOptions } from "@tanstack/react-query";
import { PageParams, Paginated, ShallowCourse } from "@vixi/types";
import { api, endpoints } from "@vixi/api";

export const hasCoursesQueryOptions = () =>
  queryOptions({
    queryKey: ["hasCourses"],
    queryFn: async () => {
      return api
        .get<Paginated<ShallowCourse>>(endpoints.getAllCourses, {
          params: {
            pageNumber: 1,
            pageSize: 1,
          } satisfies PageParams,
        })
        .then((r) => (r.data.totalCount ?? 0) > 0);
    },
  });
